import { CHANGE_AUTH_FLAG, AUTH_LOGOUT, GET_PROFILE } from './action-types';
import { remove } from 'js-cookie';

const { Storage } = require('../../../../configs/lib');

export function changeAuthFlag(payload: boolean, authToken: any) {
    return {
        type: CHANGE_AUTH_FLAG,
        payload,
        authToken,
    };
}

export function authLogout() {
    Storage.removeItem('adminToken');
    remove('session', { path: '/' });
    document.cookie = 'session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    return {
        type: AUTH_LOGOUT,
    };
}

export function getProfile(payload: any) {
    return {
        type: GET_PROFILE,
        ...payload,
    };
}
